<template>
  <div
    class="a4-page"
    style="
      position: relative;
      background-color: var(--color-white);
      border: 1px solid var(--color-light-gray);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      width: 100%;
      aspect-ratio: 1/1.414;
      padding: 40px;
      overflow: hidden;
    "
  >
    <!-- Project Title Section -->
    <project-title-section
      :project-data="projectData"
      :include-sections="includeSections"
      :report-type="reportType"
    />

    <!-- Project Info Section -->
    <project-info-section
      v-if="includeSections.projectInfo"
      :project-data="projectData"
    />

    <!-- Services Offered Section -->
    <services-section :report-type="reportType" />

    <!-- Type of Installation Section -->
    <installation-section
      v-if="projectData?.service_type === 'complete_solution'"
      :report-type="reportType"
    />

    <!-- Footer -->
    <report-footer :report-type="reportType" />

    <!-- Page Number -->
    <div class="position-absolute bottom-0 end-0" style="padding: 20px 40px">
      <small class="text-muted" style="font-size: 12px">1</small>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from "vue";
import type { Project } from "@/types/projectTypes";
import ProjectTitleSection from "../sections/ProjectTitleSection.vue";
import ProjectInfoSection from "../sections/ProjectInfoSection.vue";
import ServicesSection from "../sections/ServicesSection.vue";
import InstallationSection from "../sections/InstallationSection.vue";
import ReportFooter from "../sections/ReportFooter.vue";

export default defineComponent({
  name: "ReportPage1",
  components: {
    ProjectTitleSection,
    ProjectInfoSection,
    ServicesSection,
    InstallationSection,
    ReportFooter,
  },
  props: {
    projectData: {
      type: Object as PropType<Project | null>,
      required: true,
    },
    includeSections: {
      type: Object as PropType<Record<string, boolean>>,
      required: true,
    },
    paymentType: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const reportType = computed(() => {
      if (props.projectData?.service_type === "complete_solution") {
        return `${props.projectData.service_type}.${props.paymentType}`;
      }
      return props.projectData?.service_type || "product_supply";
    });

    return {
      reportType,
    };
  },
});
</script>
